import {
    useContext,
    useMemo,
    useState,
} from 'react';

import { LocationContext } from 'app/containers/LocationProvider';
import { CATEGORY_READY_TO_EAT } from 'app/const/categories';
import { LOCATION_MSK } from 'app/const/location';

export const getReadyToEatDishesFromCart = (cart) => {
    const sections = cart?.sections || [];

    return sections.reduce((readyToEatDishes, section) => {
        const isReadyToEatSection = String(section?.id) === CATEGORY_READY_TO_EAT;

        (section?.items || []).forEach((item) => {
            const isReadyToEatDish = isReadyToEatSection
                || String(item?.dish?.categoryId) === CATEGORY_READY_TO_EAT;

            if (isReadyToEatDish) {
                readyToEatDishes.push(item);
            }
        });

        return readyToEatDishes;
    }, []);
};

/**
 * @description Проверяет, остались ли в корзине блюда. Нужна, чтобы после удаления
 * части корзины решить, продолжать ли оформление или отправлять пользователя в
 * корзину. Пустые позиции (portions === 0) блюдами не считаются.
 */
export const hasDishesInCart = (cart) => (cart?.sections || [])
    .some((section) => (section?.items || [])
        .some((item) => Number(item?.portions) > 0));

export const useReadyToEatContradictionCheck = (cart) => {
    const { locationKey } = useContext(LocationContext);
    const [isReadyToEatDialogShown, setIsReadyToEatDialogShown] = useState(false);

    const readyToEatDishes = useMemo(
        () => getReadyToEatDishesFromCart(cart),
        [cart],
    );

    const hasReadyToEatDishes = useMemo(
        () => readyToEatDishes.length > 0,
        [readyToEatDishes],
    );

    const hasContradiction = hasReadyToEatDishes && locationKey !== LOCATION_MSK;

    return {
        isReadyToEatDialogShown,
        setIsReadyToEatDialogShown,
        hasContradiction,
        readyToEatDishes,
    };
};
